import JsonView from '@uiw/react-json-view';
import { Wrench } from 'lucide-react';

import CollapsibleBlock from '../CollapsibleBlock';

const jsonStyle = {
  '--w-rjv-background-color': 'transparent',
  '--w-rjv-font-family':
    'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
  '--w-rjv-font-size': '0.75rem',
  '--w-rjv-key-string': '#2563eb',
  '--w-rjv-color': '#1e40af',
  '--w-rjv-type-string-color': '#059669',
  '--w-rjv-type-int-color': '#7c3aed',
  '--w-rjv-type-boolean-color': '#dc2626',
  '--w-rjv-type-null-color': '#6b7280',
} as React.CSSProperties;

export default function ToolUseField({ value }: { value: string }) {
  let toolData: { func_name?: string; func_args?: unknown } | null = null;
  try {
    const parsed = JSON.parse(value);
    let funcArgs = parsed.func_args;
    if (typeof funcArgs === 'string') {
      try {
        funcArgs = JSON.parse(funcArgs);
      } catch {
        void 0;
      }
    }
    toolData = { func_name: parsed.func_name, func_args: funcArgs };
  } catch {
    toolData = null;
  }

  if (!toolData) {
    return (
      <CollapsibleBlock
        icon={<Wrench className="h-3.5 w-3.5" />}
        label="Tool Call"
        summary="(unparseable)"
        tone="blue"
      >
        <pre className="whitespace-pre-wrap break-all font-mono text-xs">
          {value}
        </pre>
      </CollapsibleBlock>
    );
  }

  return (
    <CollapsibleBlock
      icon={<Wrench className="h-3.5 w-3.5" />}
      label={`Tool Call · ${toolData.func_name ?? 'unknown'}`}
      tone="blue"
    >
      <JsonView
        value={toolData.func_args as object}
        collapsed={false}
        displayDataTypes={false}
        displayObjectSize={false}
        style={jsonStyle}
      />
    </CollapsibleBlock>
  );
}
